<template>
  <div class="h-full overflow-x-hidden bg-gray-50">
    <div className="relative mx-auto max-w-7xl">
      <div
        class="bg-linear-115 absolute -right-60 -top-44 h-60 w-[36rem] rotate-[-10deg] transform-gpu rounded-full from-indigo-100 to-indigo-500 blur-3xl md:right-0"
      />
    </div>
    <slot />
    <Notifications />
  </div>
</template>

<script lang="ts" setup>
import { useUserStore } from '@/stores/user';
import { initLanguage } from '@/util/language-utils';

useHead({
  htmlAttrs: {
    class: 'h-full bg-gray-50',
  },
  bodyAttrs: {
    class: 'h-full',
  },
});

const i18n = useI18n();
const userStore = useUserStore();

initLanguage(userStore.user?.language, i18n);
</script>

<style scoped>
/* TODO RCP-1306: remove this style as it is built-in in tailwindcss@4 */
.bg-linear-115 {
  --tw-gradient-position: 115deg in oklab;
  background-image: linear-gradient(
    115deg,
    oklch(0.93 0.034 272.788) 0%,
    oklch(0.585 0.233 277.117) 100%
  );
}
</style>
